<template>
  <div class="systemManage-create create-image">
    <el-dialog
      v-model="dialogVisible"
      :title="$t('lcd.Devices.Setting Sleep Time')"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="600px"
    >
      <el-descriptions :column="1">
        <el-descriptions-item :label="$t('lcd.Devices.Store ID')">{{
          storeId
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('lcd.Devices.Sleep Time Range')">
          <el-time-select
            size="mini"
            :placeholder="$t('lcd.Devices.Sleep Start Time')"
            v-model="sleepStart"
            :picker-options="{
              start: '00:00',
              step: '01:00',
              end: '24:00',
            }"
            style="width: 160px; margin-right: 10px"
          >
          </el-time-select>
          -
          <el-time-select
            size="mini"
            :placeholder="$t('lcd.Devices.Sleep End Time')"
            v-model="sleepEnd"
            :picker-options="{
              start: '00:00',
              step: '01:00',
              end: '24:00',
            }"
            style="width: 160px; margin-left: 10px"
          >
          </el-time-select>
        </el-descriptions-item>
      </el-descriptions>
      <span slot="footer" class="dialog-footer">
        <el-button
          size="small"
          @click="handleClose('cancel')"
          style="background: #d4d4d4"
          >{{ $t("button.Cancel") }}</el-button
        >
        <el-button
          size="small"
          class="base-color-btn"
          type="success"
          @click="handleConfirm('confirm')"
          >{{ $t("button.Confirm") }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { storeScreenClose } from "@/libs/api/lcd";

export default {
  name: "device-setting",
  components: {},
  props: {
  },
  data() {
    return {
      detailData: {
        offTime:'',
        onTime: ''
      },
      storeId: localStorage.getItem("storeId"),
      userData: JSON.parse(localStorage.getItem("userData")),
      dialogVisible: false,
      sleepStart: '',
      sleepEnd: '',
    };
  },
  watch: {
    dialogVisible: function(val) {
      if(val){
        // 后端称：onTime是开始息屏幕时间    offTime是结束屏幕时间
        this.sleepEnd = this.detailData.offTime
        this.sleepStart = this.detailData.onTime
      }
    }
  },
  created() {},
  mounted() {},
  methods: {
    // 打开弹窗
    open() {
      this.dialogVisible = true;
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
    },
    handleConfirm() {
      console.log(123)
      if (!this.sleepStart || !this.sleepEnd) {
        this.$message.error(this.$t('lcd.Devices.Please set the sleep time'));
        return;
      }
      const params = {
        storeId: localStorage.getItem("storeId"),
        taskTerminal: 0,
        sleepStart: this.sleepStart,
        sleepEnd: this.sleepEnd,
      };
      console.log(params)
      storeScreenClose(params).then((res) => {
        console.log(res);
        if(res.data.code == 1){
          this.$message.success(this.$t('lcd.Devices.Setting Success'))
          this.$emit('reGetList')
          this.dialogVisible = false
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.systemManage-create.create-image {
  ::v-deep
    .el-descriptions__body
    .el-descriptions__table
    .el-descriptions-item__cell {
    line-height: 28px;
  }
  .el-button {
    width: 110px;
  }
  .dialog-footer {
    padding-bottom: 20px;
  }
  .form-box {
    width: 500px;
  }
  .file-list {
    display: flex;
  }
  .form-btn-section {
    margin-top: 0px;
  }
  ::v-deep .el-tag {
    margin-bottom: 10px;
    max-width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    position: relative;
    padding-right: 30px;
    // word-wrap: break-word;
    // word-break: break-all;
    .el-icon-close {
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}
</style>